import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import { range } from '@utils/array';

import './CardSkeleton.scss';

interface CardListSkeletonProps {
    panelCount?: number;
}

const SkeletonListItem = () => (
    <div className="skeleton-list__item">
        <Skeleton className="skeleton-list__card-image" />

        <div className="skeleton-list__card-info">
            <Skeleton className="skeleton-list__card-name" />
            <Skeleton className="skeleton-list__card-number" />
        </div>
    </div>
);

export const CardSkeleton = ({ panelCount = 2 }: CardListSkeletonProps) => {
    return (
        <div className="skeleton-list">
            <SkeletonTheme baseColor="#fff" highlightColor="#f7f4f2">
                <Skeleton className="skeleton-list__title" />
                <div className="skeleton-list__items">
                    {range(panelCount).map((key) => (
                        <SkeletonListItem key={key} />
                    ))}
                </div>
            </SkeletonTheme>
        </div>
    );
};

export default CardSkeleton;
